// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-node {
  -webkit-user-select: none;
          user-select: none;
}
.tree-node__label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.1rem 0.35rem;
  font-size: 1.05rem;
  border-radius: 0.2rem;
  cursor: pointer;
  transition: background-color 0.1s;
}
.tree-node__label:hover {
  background-color: #f0f4f8;
}
.tree-node__label--selected {
  background-color: #dbe9f9;
  font-weight: 600;
}
.tree-node__label--job {
  font-weight: 700;
}
.tree-node__label--lookup {
  font-weight: 800;
}
.tree-node__label--project {
  font-weight: 600;
  color: #6b6d6f;
}
.tree-node__label--leaf {
  cursor: default;
}
.tree-node__label--leaf:hover {
  background-color: transparent;
}
.tree-node__arrow {
  display: inline-block;
  width: 1.25rem;
  font-size: 2rem;
  line-height: 1;
  font-weight: 700;
  color: #6c757d;
  flex-shrink: 0;
  text-align: center;
  margin-left: auto;
}
.tree-node__arrow--spacer {
  visibility: hidden;
}
.tree-node__text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tree-node__children {
  padding-left: 1.25rem;
  border-left: 1px solid #dee2e6;
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tree-node/tree-node.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;UAAA,iBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,iCAAA;AADJ;AAGI;EACE,yBAAA;AADN;AAII;EACE,yBAAA;EACA,gBAAA;AAFN;AAKI;EACE,gBAAA;AAHN;AAMI;EACE,gBAAA;AAJN;AAOI;EACE,gBAAA;EACA,cCdM;ADSZ;AAQI;EACE,eAAA;AANN;AAQM;EACE,6BAAA;AANR;AAWE;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AATJ;AAWI;EACE,kBAAA;AATN;AAaE;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAXJ;AAcE;EACE,qBAAA;EACA,8BAAA;EACA,mBAAA;AAZJ","sourcesContent":["\n@use '../../../../styles/colors' as colors;\n.tree-node {\n  user-select: none;\n\n  &__label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.1rem 0.35rem;\n    font-size: 1.05rem;\n    border-radius: 0.2rem;\n    cursor: pointer;\n    transition: background-color 0.1s;\n\n    &:hover {\n      background-color: #f0f4f8;\n    }\n\n    &--selected {\n      background-color: #dbe9f9;\n      font-weight: 600;\n    }\n\n    &--job {\n      font-weight: 700;\n    }\n\n    &--lookup {\n      font-weight: 800;\n    }\n\n    &--project {\n      font-weight: 600;\n      color: colors.$dark-gray;\n    }\n\n    &--leaf {\n      cursor: default;\n\n      &:hover {\n        background-color: transparent;\n      }\n    }\n  }\n\n  &__arrow {\n    display: inline-block;\n    width: 1.25rem;\n    font-size: 2rem;\n    line-height: 1;\n    font-weight: 700;\n    color: #6c757d;\n    flex-shrink: 0;\n    text-align: center;\n    margin-left: auto;\n\n    &--spacer {\n      visibility: hidden;\n    }\n  }\n\n  &__text {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__children {\n    padding-left: 1.25rem;\n    border-left: 1px solid #dee2e6;\n    margin-left: 0.5rem;\n  }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
